import { FC, Fragment, memo, useMemo } from 'react';

interface Props {
	text?: string;
	search?: string;
}

export const Highlighter: FC<Props> = memo(
	({ text = '', search = '' }): JSX.Element => {
		/**
		 * The brackets around the re variable keeps it in the array when splitting and does not affect testing
		 * @example 'react'.split(/(ac)/gi) => ['re', 'ac', 't']
		 */
		const re = useMemo(() => {
			const SPECIAL_CHAR_RE = /([.?*+^$[\]\\(){}|-])/g;
			const escapedSearch = search.replace(SPECIAL_CHAR_RE, '\\$1');
			const decoded = decodeURIComponent(escapedSearch);
			return new RegExp(decoded.split(' ').join('|'), 'ig');
		}, [search]);

		const matches = [...text.matchAll(re)];

		return (
			<span>
				{search === ''
					? text
					: text.split(re).map((part, index, arr) => (
							<Fragment key={index}>
								{part}
								{index + 1 !== arr.length && (
									<mark className="mark">
										{matches[index]}
									</mark>
								)}
							</Fragment>
						))}
			</span>
		);
	}
);
Highlighter.displayName = 'Highlighter';
